import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import NotFound from '@/components/NotFound'
import About from '@/components/About'
import Signup from '@/components/Signup'
import Terms from '@/components/Terms'
import Privacy from '@/components/Privacy'

Vue.use(Router)

Vue.component('navbar', require('@/components/Partials/Navbar.vue'))
Vue.component('footer', require('@/components/Partials/Footer.vue'))

const router = new Router({
  mode: 'history',
  routes: [
    { path: '*', component: NotFound, name: 'notFound', meta: {title: 'Not Found'} },
    { path: '/', component: Home, name: 'home', meta: {title: 'LeadSocial', Navbar: false, Footer: true} },
    { path: '/about', component: About, name: 'about', meta: {title: 'About', Navbar: false, Footer: true} },
    { path: '/about/terms', component: Terms, name: 'terms', meta: {title: 'Terms', Navbar: true, Footer: true} },
    { path: '/about/privacy', component: Privacy, name: 'privacy', meta: {title: 'Privacy', Navbar: true, Footer: true} },
    { path: '/signup', component: Signup, name: 'signup', meta: {title: 'Signup', Navbar: true, Footer: true} }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  // Start our vue-progressbar
  router.app.$Progress.start()

  // To set the title of each route
  document.title = to.meta.title
  next()
})

router.afterEach((to, from) => {
  // End our vue-progressbar
  router.app.$Progress.finish()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js